import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
//window.axios = require('axios')
import VueAnalytics from 'vue-analytics'
import axios from 'axios'

import VuejsDialog from 'vuejs-dialog';

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

import Api from "./mixins/Apicall";
import Appsettings from "./mixins/AppSettings";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueI18n from 'vue-i18n'
import { ENGLISH_TRANSLATIONS } from '@/localization/en';
import { IRISH_TRANSLATIONS } from '@/localization/ga';

import { SimpleSVG } from 'vue-simple-svg'
Vue.component('simple-svg', SimpleSVG)
import InlineSvg from 'vue-inline-svg';
Vue.component('inline-svg', InlineSvg);

Vue.use(VueAnalytics, {
  id: 'UA-180437481-1'
})
Vue.config.productionTip = false
let app = '';

Vue.use(VueI18n)

Vue.prototype.$http = axios;

Vue.mixin(Api);

Vue.mixin(Appsettings);

Vue.use(VuejsDialog);

const TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  ga: IRISH_TRANSLATIONS
}
const i18n = new VueI18n({
  locale: 'en',
  messages: TRANSLATIONS,
})

// var config = {
//   apiKey: "AIzaSyDmWs2jx5z4KOga0NB_-6fwbh9mjNHOo7o",
//   authDomain: "pinpoint-m5j10.firebaseapp.com",
//   databaseURL: "https://pinpoint-m5j10.firebaseio.com",
//   projectId: "pinpoint-m5j10",
//   storageBucket: "pinpoint-m5j10.appspot.com",
//   messagingSenderId: "1081795751393",
//   appId: "1:1081795751393:web:3e9484afd4c42deed0f6a0"
// };

const config = {
  apiKey: "AIzaSyCCWtghuWDg6zF25YLxDJJtZdA15Z14sKM",
  authDomain: "c2g-cyclerouteplatform.firebaseapp.com",
  projectId: "c2g-cyclerouteplatform",
  storageBucket: "c2g-cyclerouteplatform.appspot.com",
  messagingSenderId: "307770597418",
  appId: "1:307770597418:web:9e9ecfa93d6c8821c1a353",
  measurementId: "G-41W771MD5T"
};

firebase.initializeApp(config);

const db = firebase.firestore();

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      firebase,
      i18n,
      render: h => h(App)
    }).$mount('#app')

    window.app = app;
  }
});

export default db;

